export const PARTY = {
  dateISO: "2026-09-24T19:30:00",
  locationLines: [
    "COORDINATES: 37.7819 S // 144.9841 E",
    "218 PARK STREET, FITZROY NORTH",
    "DOORS 19:30 - LATE",
    "FOLLOW THE GREEN GLOW",
  ],
  acts: [
    { name: "DJ Deez Rats Aint Loyal", time: "21:00" },
    { name: "Doctor RATTUS", time: "22:00" },
    { name: "DANRAT", time: "23:00" },
    { name: "DJ Ratgott xo", time: "00:00", tag: "Gay Mode" },
  ],
};
